import { render, staticRenderFns } from "./ProductRecommond.vue?vue&type=template&id=6927cca1&scoped=true&"
import script from "./ProductRecommond.vue?vue&type=script&lang=js&"
export * from "./ProductRecommond.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecommond.vue?vue&type=style&index=0&id=6927cca1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6927cca1",
  null
  
)

export default component.exports